import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { revealUp } from "../../lib/mrs";

const PHIL_IMG = "https://images.unsplash.com/photo-1718220268527-4477fd170775";

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      id="philosophy"
      ref={ref}
      data-testid="philosophy-section"
      className="relative bg-[#0a0b0a] py-24 md:py-32 lg:py-48 px-6 md:px-12 lg:px-20"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <motion.span
            variants={revealUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            className="block font-num text-[#b89b72]/30 leading-none text-[120px] md:text-[180px] lg:text-[220px] -ml-1 mb-2 select-none"
          >
            01
          </motion.span>
          <motion.p
            variants={revealUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="text-[11px] md:text-sm tracking-[0.28em] uppercase text-[#b89b72] mb-6"
          >
            Our Philosophy
          </motion.p>
          <motion.h2
            variants={revealUp}
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            data-testid="philosophy-heading"
            className="font-display font-light text-[#eae7e0] leading-[1.05] text-4xl md:text-5xl lg:text-6xl tracking-tight max-w-2xl"
          >
            Nature wasn&apos;t meant to be optional.
          </motion.h2>
          <motion.div
            variants={revealUp}
            custom={2}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="mt-8 space-y-6 max-w-xl text-base md:text-lg text-[#9ca399] leading-relaxed"
          >
            <p>
              As cities grow denser and spaces shrink, we lose our everyday
              connection to the natural world. We exist to give back, a living
              element in every home and workplace, however dense the city gets
              around it.
            </p>
            <p className="text-[#eae7e0] font-display text-2xl md:text-3xl leading-snug italic">
              &ldquo;Every design should offer a connection to the outdoors,
              seamlessly integrated into the way we live.&rdquo;
            </p>
          </motion.div>
        </div>

        <div className="lg:col-span-5 order-1 lg:order-2">
          <motion.div
            variants={revealUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="relative overflow-hidden aspect-[3/4] w-full"
          >
            <motion.img
              style={{ y: imgY }}
              src={PHIL_IMG}
              alt="Biophilic interior with natural greenery"
              className="w-full h-[116%] object-cover"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-[#eae7e0]/10" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
